import styled from 'styled-components';
import {
  Alert,
} from 'antd';

export const StyledAntdAlert = styled(Alert)`
`;
